import script from "./DomainModelWriteModel.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainModelWriteModel.vue?vue&type=script&setup=true&lang=js"

import "./DomainModelWriteModel.vue?vue&type=style&index=0&id=a52b3356&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a52b3356"]])

export default __exports__